"use strict";

exports.__esModule = true;
exports.version = "0.4.1";